import React, { useState } from "react";
import classNames from "classnames";
import { API, Auth } from "aws-amplify";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import {
  reinstallments,
  calcuratorInterestTwo,
} from "../../utils/reinstallments";
import { calReportAging } from "../../utils/calReportAging";
import { getCurrentLocalDateTime, pad } from "../../utils/getLocalDateTime";
import axios from "axios";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function AgingExport({ selectToday }) {
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [dataPrinciple, setDataPrinciple] = useState([]);
  const [dataInterest, setDataInterest] = useState([]);

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const nextFetch = () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, 1000);
    });
  };

  const onClickAging = async () => {
    try {
      setLoading(true);
      let data = {};
      let localCount = 0;
      let lastItem = null;
      let keepLoan = [];
      const dataResponse = await await API.get("MoneyHubAdmin", "/interest", {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      const interest = JSON.parse(dataResponse.body) || {};
      const selectMonth = new Date(selectToday);
      let today = new Date(selectToday);
      let lastDate = today.getDate();
      let paid_date = "";
      if (selectMonth.getMonth() === today.getMonth()) {
        paid_date = `${selectMonth.getFullYear()}-${pad(
          selectMonth.getMonth() + 1
        )}-${pad(today.getDate())}`;
      } else {
        const newToday = new Date(
          selectMonth.getFullYear(),
          selectMonth.getMonth() + 1,
          0
        );
        lastDate = newToday.getDate();
        paid_date = `${selectMonth.getFullYear()}-${pad(
          selectMonth.getMonth() + 1
        )}-${pad(newToday.getDate())}`;
      }
      do {
        const { data: localData } = await axios.get(
          "https://jdr4sjrq6phvrouxu4np6d62gm0ufwmq.lambda-url.ap-southeast-1.on.aws/loan/sandbox/agingReport",
          {
            params: {
              paid_date: selectToday,
              ExclusiveStartKey: getLastItem(lastItem),
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          }
        );

        data = localData;

        // data = await API.get("MoneyHubAdmin", "/loan/sandbox/agingReport", {
        //   queryStringParameters: {
        //     // paid_date: "2024-01-13",
        //     // ExclusiveStartKey:
        //     //   "isCreated=true&requestTimeFullDate=2022-02-25&loan_id=L0985710975_250265_0700_3&",
        //     paid_date: selectToday,
        //     ExclusiveStartKey: getLastItem(lastItem),
        //   },
        //   headers: {
        //     Authorization: `Bearer ${(await Auth.currentSession())
        //       .getIdToken()
        //       .getJwtToken()}`,
        //   },
        // });

        lastItem = data?.lastItem;
        let where = {
          paid_date,
        };
        let dataInterest = interest;
        let buroDate = paid_date;
        let filterLoan = data?.Items?.filter((item) => !item?.refinance_amount)
          ?.map((loan) => {
            // const newLoan = reinstallments(loan, buroDate, dataInterest);
            let newLoan = loan;

            if (loan?.loan_status === "DONE") {
              let lastEvidence = loan.evidence[loan.evidence.length - 1];
              let lastPaidDate = getCurrentLocalDateTime(
                new Date(lastEvidence.paid_date)
              );
              if (
                lastPaidDate.fullDate > getCurrentLocalDateTime(buroDate).fullDate
              ) {
                newLoan = reinstallments(loan, buroDate, dataInterest);
              }
            }


            const calNewLoan = calcuratorInterestTwo(
              { ...loan, ...newLoan },
              {
                where,
                dataInterest,
              }
            );

            let includeLoan = { ...calNewLoan, ...newLoan };
            // console.log("includeLoan", includeLoan);
            // if (includeLoan.evidence.length > 0) {
            // let lastPaymentDate = getCurrentLocalDateTime(
            //   includeLoan.evidence[includeLoan.evidence.length - 1].date
            // ).fullDate;
            if (
              // lastPaymentDate <= "2022-03-31" &&
              // lastPaymentDate >= "2022-03-01" &&
              // includeLoan.loan_status === "DONE"
              includeLoan.loan_status === "ACTIVE" ||
              includeLoan.loan_status === "FAIL"
            ) {
              return { ...calNewLoan, ...newLoan };
            }
            // }
          })
          .filter((item) => item);
        localCount += filterLoan?.length;
        keepLoan.push(...filterLoan);
        setCount(localCount);
        // await nextFetch();
      } while (lastItem);

      let { dataPrinciple, dataInterest } = calReportAging(
        keepLoan,
        new Date(paid_date)
      );

      dataPrinciple = dataPrinciple.filter((principle) => principle.total > 0);

      setDataPrinciple(dataPrinciple);
      setDataInterest(dataInterest);
      setCount(dataPrinciple.length - 1);
      const getExportId = document.getElementById("export-excel-aging-sandbox");
      getExportId.click();
    } catch (error) {
      console.log("loading error", error);
    } finally {
      setLoading(false);
    }
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    for (let i = 0; i < data.length; i++) {
      var filled =
        i == data.length - 1
          ? { patternType: "solid", fgColor: { rgb: "FEFF54" } }
          : { fgColor: { rgb: "FFFFFF" } };
      var filled_col_0 =
        i == data.length - 1
          ? { fgColor: { rgb: "FFFFFF" } }
          : { patternType: "solid", fgColor: { rgb: "FDFFA7" } };
      result.push([
        {
          value: `${data[i].reference || ""}`,
          style: { font: { sz: 14 }, alignment: "right", fill: filled_col_0 },
        },
        {
          value: data[i]?.name || "",
          style: { font: { sz: 14 }, alignment: "right" },
        },
        {
          value: data[i].loan_status || "",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i].notDue,
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i][30],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]["31_90"],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]["91_180"],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]["181_365"],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i][365],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: +data[i].total,
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]?.requestTimeFullDate || "",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
      ]);
    }
    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "Reference",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "Name",
          width: { wch: 30 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "Status",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "4287f5" } } },
        }, //pixels width
        {
          title: "Not Due",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        }, //char width
        {
          title: "0 - 30",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "31 - 90",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "91 - 180",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "181 - 365",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "> 365",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "Total",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "วันที่สร้าง",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
      ],
      data: createDataWithStyle(dataPrinciple),
    },
  ];

  const multiDataSetInterest = [
    {
      columns: [
        {
          title: "Reference",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "Name",
          width: { wch: 30 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "Status",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "4287f5" } } },
        }, //pixels width
        {
          title: "Not Due",
          width: { wch: 18 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        }, //char width
        {
          title: "0 - 30",
          width: { wch: 18 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "31 - 90",
          width: { wch: 18 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "91 - 180",
          width: { wch: 18 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "181 - 365",
          width: { wch: 18 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "> 365",
          width: { wch: 18 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "Total",
          width: { wch: 24 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "วันที่สร้าง",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
      ],
      data: createDataWithStyle(dataInterest),
    },
  ];

  return (
    <div>
      <ExcelFile
        filename={`REPORT_${format(new Date(selectToday), "yyyy-MM-dd")}`}
        element={<button id="export-excel-aging-sandbox" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="Principle"></ExcelSheet>
        {/* <ExcelSheet dataSet={multiDataSetInterest} name="Interest"></ExcelSheet> */}
      </ExcelFile>
      <button
        disabled={loading}
        className={classNames(
          "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
          {
            "bg-green-500": !loading,
            "bg-gray-400": loading,
          }
        )}
        onClick={onClickAging}
      >
        {loading && (
          <svg
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx={12}
              cy={12}
              r={10}
              stroke="currentColor"
              strokeWidth={4}
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          />
        </svg>
        {count > 0 && `(${count})`} Aging Report
      </button>
    </div>
  );
}

export default AgingExport;
